<template>
    <base-box
        v-if="tags.length > 0"
        background-color="grey"
        class="margin-bottom-large"
    >
        <div slot="content" class="no-margins">
            <g-typography tag="span" font-weight="semibold">
                {{ description }}:
            </g-typography>
            <g-typography tag="span" :value="tags" />
        </div>
    </base-box>
</template>

<script>
    import _ from 'lodash';

    export default {
        name:  'TagsBox',
        props: {
            tags: {
                type:    String,
                default: '',
            },
            customDescription: {
                type: String,
            },
        },
        computed: {
            description(){
                return this.customDescription ? _.trimEnd(this.customDescription, ':') : 'Please be sure to use these tags in your post';
            },
        },
    };
</script>
